import { createSelector } from 'reselect';

// Config
import { getStripeCheckoutFlowEnabledSelector } from '@components/streamlined-payments/pay-now-category/AddNewCard.state';

const applePayButtonState = createSelector([getStripeCheckoutFlowEnabledSelector], (stripeCheckoutFlowEnabled) => ({
  stripeCheckoutFlowEnabled,
}));

export default applePayButtonState;
